export default "__VITE_ASSET__10c05057__"